import { BodyText, Button, HeadlineText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import decideImage from "src/pods/conundrums/assets/decide.png";
import listenImage from "src/pods/conundrums/assets/listen.png";
import reflectImage from "src/pods/conundrums/assets/reflect.png";
import { BackButton } from "src/shared/components/BackButton";
import { RemoteSlideProps, Slide } from "./types";

const EmojiBlock: React.FC<{
  image: string;
  text: string;
  cssStyle: ThemeUIStyleObject;
}> = ({ image, text, cssStyle }) => {
  return (
    <span sx={cssStyle}>
      <div sx={{ padding: RAW_cssValue("6px 18px 12px") }}>
        <img src={image} sx={{ width: "40px" }} />
      </div>
      <div>{text}</div>
    </span>
  );
};

export const IntroSlide = (
  title: string,
  description: string,
  question: string,
  conundrumImage: string,
  imageStyle?: ThemeUIStyleObject,
  duration?: string,
): Slide => {
  return {
    remote: ({ next, goToTeacherTips }: RemoteSlideProps) => (
      <div sx={appStyle}>
        <div>
          <div sx={{ ...flexCenter, position: "relative" }}>
            <BackButton onClick={() => next(-1)} />
            <HeadlineText as="h3">{title}</HeadlineText>
          </div>
          <BodyText sx={descriptionStyle}>
            {description} <b>{question}</b>
          </BodyText>
          <BodyText level={2} kind="secondary">{`${duration ? duration : "10-20"} min activity`}</BodyText>

          <img
            src={conundrumImage}
            sx={{ marginTop: RAW_cssValue("24px"), maxHeight: "172px", maxWidth: "80%", ...imageStyle }}
            alt="Conundrum image"
          />
          <div sx={tagsWrapperStyle}>
            <div sx={{ ...flexCenter, margin: RAW_cssValue("6px 6px 0 6px") }}>
              <div sx={tagsWrapper}>
                <EmojiBlock image={listenImage} text="Listen" cssStyle={tagPadding} />
                <EmojiBlock image={decideImage} text="Decide" cssStyle={centerTag} />
                <EmojiBlock image={reflectImage} text="Reflect" cssStyle={tagPadding} />
              </div>
            </div>
          </div>
        </div>
        <div sx={buttonsWrapper}>
          <Button data-name="intro_slide:remote:intro_slide.teacher_tips" kind="tertiary" onClick={goToTeacherTips}>
            Teacher Tips
          </Button>
          <Button data-name="intro_slide:remote:intro_slide.start_now" onClick={() => next()}>
            Start Now
          </Button>
        </div>
      </div>
    ),
  };
};

const tagsWrapperStyle: ThemeUIStyleObject = {
  backgroundColor: "dt_background_primary",
  zIndex: 2,
  position: "relative",
  "@media (max-width: 320px)": {
    display: "none",
  },
};

const appStyle: ThemeUIStyleObject = {
  textAlign: "center",
  padding: RAW_cssValue("20px"),
};

const buttonsWrapper: ThemeUIStyleObject = {
  marginTop: RAW_cssValue("15px"),
  display: "flex",
  justifyContent: "space-evenly",
  flexWrap: "wrap",
  alignItems: "center",
};

const flexCenter: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const tagsWrapper: ThemeUIStyleObject = {
  display: "inline-flex",
  boxShadow: `dt_shadow_shadezies`,
  border: `dt_disabled`,
  borderBottomLeftRadius: "dt_radius_s",
  borderTopLeftRadius: "dt_radius_s",
  borderBottomRightRadius: "dt_radius_s",
  borderTopRightRadius: "dt_radius_s",
};

const tagPadding: ThemeUIStyleObject = {
  padding: RAW_cssValue("12px 18px"),
};

const centerTag: ThemeUIStyleObject = {
  ...tagPadding,
  border: `dt_card`,
  borderTopStyle: "hidden",
  borderBottomStyle: "hidden",
};

const descriptionStyle: ThemeUIStyleObject = {
  marginTop: "dt_s",
  marginBottom: "dt_m",
};
